import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { COLLECTIONS_PATH } from '~/constants';
import { trackLeafioEvent } from '~/utils/trackLeafioEvent';

/**
 * Sends search_error when a products page search fails. A failed search replaces the
 * products page with the error page, so this runs from the error boundary.
 * @param error - The error the boundary caught
 * @param errorStatus - The error's HTTP status, when it has one
 */
export const useTrackSearchError = (error: unknown, errorStatus?: number) => {
  const { pathname, search } = useLocation();
  const query = new URLSearchParams(search).get('query');
  const isSearch = pathname.startsWith(COLLECTIONS_PATH) && !!query;

  useEffect(() => {
    if (isSearch && query) {
      trackLeafioEvent('search_error', 'GenericErrorBoundary', {
        query,
        errorType: errorStatus ? String(errorStatus) : 'unknown',
      });
    }
    // Fires once per error caught
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);
};
